/* global window */
import * as React from 'react';
import {Note} from '@packages/systems/spring';
import {Link} from '@packages/systems/design-system/Link';
import {useTheme} from '@packages/utilities/styled';
import {Plugins, TypeImplementation} from '@packages/systems/wfdl';
import {ELiteral} from '@packages/systems/wfdl-ast';
import {qualify, typeName} from '@packages/systems/wfdl-Qualified';
import {updateExpressionAction} from '@packages/systems/ExpressionEditor-utils';

const createLiteralExpr = (value: boolean) =>
  ELiteral({
    name: qualify(Plugins.name('Commerce'), typeName('DismissibleNote')),
    value,
  });

const DismissibleNote = ({
  dismissed,
  dispatch,
  content,
  universityLink,
}: {
  dismissed: boolean;
  dispatch: TypeImplementation.ExpressionEditorDispatch;
  content: string;
  universityLink?: string;
}) => {
  const theme = useTheme();

  return !dismissed ? (
    <div style={{gridColumnStart: 1, gridColumnEnd: 3}}>
      <Note hasIcon={false} colorVariant="default">
        {content}
        <div
          style={{
            display: 'flex',
            flex: 1,
            justifyContent: 'space-between',
            marginTop: theme.gutters.x4,
          }}
        >
          {universityLink ? (
            <Link onClick={() => window.open(universityLink, '_blank')}>
              Learn more
            </Link>
          ) : null}
          <Link
            onClick={() =>
              dispatch(updateExpressionAction(createLiteralExpr(true)))
            }
          >
            OK, got it
          </Link>
        </div>
      </Note>
    </div>
  ) : null;
};

export default DismissibleNote;
